import type { TextStyle_TextAlignment } from 'ricos-schema';

import { isTextAlignmentStyle } from './is-text-alignment-style';

export const getEnumByStyle = (
  textAlign: string | undefined,
  fallback: TextStyle_TextAlignment
): TextStyle_TextAlignment => {
  const textAlignUpperCase = textAlign?.toUpperCase();
  if (!isTextAlignmentStyle(textAlignUpperCase)) {
    return fallback;
  }

  return textAlignUpperCase;
};
